const automator = (Prism) => {
  Prism.languages.automator = {
    timestamp: /^\d{13}/gm,
    error: /JavaScript error/,
    warning: /JavaScript warning/,
  };
};

automator.displayName = 'automator';
automator.aliases = [];

export default automator;
